// pages/Dashboard.jsx
import Team from "../components/teamComponents/Team";
import HomeLayout from "../components/HomeLayout";

export default function TeamPage() {
  return (
    <HomeLayout>
      <Team />
    </HomeLayout>
  );
}
